/* eslint-disable */
export default {
  cancel: 'Cancelar',
  reply: 'Responder',
  onMyWay: 'Estou a caminho',
  customMessage: 'Mensagem personalizada',
  callMeBackIn: 'Volte a ligar-me dentro de',
  willCallYouBackIn: 'Ligarei de volta dentro de',
  min: 'min',
  hours: 'horas',
  days: 'dias',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
